import React from "react"

export interface VideoSurfaceProps {
  className?: string
  video: {
    streamingUrl?: string
    low: string
    medium: string
    high: string
  }
}

const VideoSurface = (props: VideoSurfaceProps) => {
  const className = props.className || "c-video-surface"
  return (
    <video
      loop={true}
      autoPlay={true}
      muted
      playsInline={true}
      className={className}
    >
      {/* {props.video.streamingUrl && (
        <source src={props.video.streamingUrl} type="application/x-mpegURL" />
      )} */}
      <source src={props.video.high} type="video/mp4" />
    </video>
  )
}

export default VideoSurface
